import React from "react";
import styled from "styled-components";

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  #modal {
    background: var(--mainWhite);
  }
  .modal-header {
    background: var(--mainBlack);
    color: var(--mainWhite);
  }
`;

const Modal = (props) => {
  return (
    <ModalWrapper>
      <div id="modal">
        <div className="modal-header text-center text-uppercase py-2 font-weight-bold">
          {props.header || "Error"}
        </div>
        <div
          className="modal-body text-center text-capitalize py-4"
          style={{ fontSize: "2.5rem" }}
        >
          {props.error || "An error occurred"}
        </div>
        <div className="modal-footer text-right">
          <button
            className="btn btn-outline-dark font-weight-bold"
            onClick={props.onClear}
          >
            Close
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default Modal;
